import React from 'react'
import Category from '../../Components/Category'
import Featured from '../../Components/Featured'


const Home = () => {
    return (
        <div>
            <Category/>
            <Featured/>
        </div>
    )
}

export default Home
